module.exports = __webpack_public_path__ + "static/img/m_name.5382c55.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/tysdags/m_name.png
// module id = 8n0A
// module chunks = 7